"use strict";

const _this = {

    $dom: {
        loadMore: $('.load-more'),
        wrapper: $('.articles__wrapper')
    },

    vars: {
        controller: null
    },


    init: function () {
        _this.bind();
    },

    bind: function () {
        _this.$dom.loadMore.on('click', _this.loadMore);
    },
    loadMore: async function (e) {
        e.preventDefault();

        if (_this.vars.controller) {
            controller.abort();
        }

        const data = new FormData();
        let offset = _this.$dom.wrapper.children().length;
        let total = _this.$dom.loadMore.data('total');

        data.append('action', 'posts_load_more');
        data.append('nonce', theme.nonce);
        data.append('offset', offset);


        _this.vars.controller = new AbortController();

        let signal = _this.vars.controller.signal;

        const response = await fetch(theme.ajaxUrl, {
            method: 'POST',
            body: data,
            signal
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const posts = await response.text();

        if (posts) {
            _this.$dom.wrapper.append(posts);
            _this.vars.controller = null;
            const wrapper = $('.articles__wrapper');
            if (total ===  wrapper.children().length) {
                _this.$dom.loadMore.remove();
            }
        }
    }
}


export default _this;